<template>
  <div class="player">
    <div class="player-controls">
      <div id="seek" class="timeInfo">
        <div class="player-time">
          <div class="player-time-current">
            {{ this.currentSeconds | convertTimeHHMMSS }}
          </div>
          <div class="player-time-total">
            {{ this.durationSeconds | convertTimeHHMMSS }}
          </div>
        </div>
        <div v-on:click="seek" class="player-progress" title="Seek">
          <div
            :style="{ width: this.percentComplete + '%' }"
            class="player-seeker"
          ></div>
        </div>
      </div>
    </div>
    <v-btn class="audioBtn" @click="updatePlaying">
      <div style="display:flex;align-items:center;" v-if="!playing">
        <div style="display:flex;align-items:center;margin-right:10px;">
          <PlayIcon />
        </div>
        {{$t('audioPlayer.listenAudio')}}
      </div>
      <div style="display:flex;align-items:center;" v-else>
        <div style="display:flex;align-items:center;margin-right:10px;">
          <StopIcon />
        </div>
        {{$t('audioPlayer.stopAudio')}}
      </div>
    </v-btn>
    <audio
      :loop="looping"
      ref="audio"
      :src="file"
      v-on:timeupdate="update"
      v-on:loadeddata="load"
      v-on:pause="pause"
      v-on:play="play"
      v-on:ended="onend"
      preload="auto"
      style="display: none;"
    ></audio>
  </div>
</template>
<script>
import PlayIcon from "../components/icons/PlayIcon";
import StopIcon from "../components/icons/StopIcon";
import { mapActions, mapState } from "vuex";
export default {
  name: "AudioPlayer",
  components: {
    PlayIcon,
    StopIcon,
  },
  props: {
    file: String,
    autoPlay: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    toggle: {
      type: Boolean,
      default: false,
    },
    silence: {
      type: Number,
      default: 0,
    },
    stopAudio: { type: Function },
    onEnd: { type: Function },
  },
  data: () => ({
    currentSeconds: 0,
    durationSeconds: 0,
    currentSilence: 0,
    loaded: false,
    looping: false,
    previousVolume: 35,
    interval: null,
    showVolume: false,
    volume: 100,
  }),
  created() {
    this.looping = this.loop;
  },
  mounted() {
    this.durationSilence = this.silence;
  },
  computed: {
    ...mapState(["playing", "currentAudioId", "allPlay", "selectedProject"]),

    muted() {
      return this.volume / 100 === 0;
    },
    percentComplete() {
      return parseInt((this.currentSeconds / this.durationSeconds) * 100);
    },
  },
  filters: {
    convertTimeHHMMSS(val) {
      let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);

      return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
    },
  },
  watch: {
    playing: function() {
      if (this.playing) {
        if (this.currentSilence === this.silence) {
          var playPromise = this.$refs.audio.play();
          // In browsers that don’t yet support this functionality,
          // playPromise won’t be defined.
          if (playPromise !== undefined) {
            playPromise
              .then(function() {
                // Automatic playback started!
              })
              .catch(function(error) {
                console.log(error);
                // Automatic playback failed.
                // Show a UI element to let the user manually start playback.
              });
          }
        } else {
          this.interval = setInterval(() => {
            this.currentSilence += 100;
            if (this.currentSilence === this.silence) {
              this.$refs.audio.play();
              clearInterval(this.interval);
            }
          }, 100);
        }
      } else {
        if (this.currentSilence === this.silence) {
          this.$refs.audio.pause();
        } else {
          clearInterval(this.interval);
        }
      }
    },
    volume: function() {
      this.$refs.audio.volume = this.volume / 100;
    },
    toggle: function() {
      this.stopAudios();
    },
    currentSilence: function() {
      this.currentSeconds = parseInt(this.currentSilence / 1000);
    },
  },
  methods: {
    onend() {
      this.currentSilence = 0;
      if (this.onEnd !== undefined) {
        this.onEnd();
      }
    },
    ...mapActions(["play", "pause", "pauseAllPlay", "playAllPlay"]),
    updatePlaying() {
      if (this.playing) {
        this.pause();
        if (this.allPlay) {
          this.pauseAllPlay();
        }
      } else {
        this.play();
        if (this.currentAudioId !== null) {
          this.playAllPlay();
        }
      }
    },
    download() {
      this.stopPlayer();
      window.open(this.file, "download");
    },
    load() {
      if (this.$refs.audio.readyState >= 2) {
        this.loaded = true;
        this.durationSeconds =
          parseInt(this.$refs.audio.duration) + parseInt(this.silence / 1000);
        if (this.autoPlay) {
          this.play();
        }

        return this.autoPlay;
      }

      throw new Error("Failed to load sound file.");
    },
    mute() {
      if (this.muted) {
        return (this.volume = this.previousVolume);
      }

      this.previousVolume = this.volume;
      this.volume = 0;
    },
    seek(event) {
      if (!this.loaded) return;

      const el = event.target.getBoundingClientRect();
      const seekPos = (event.clientX - el.left) / el.width;

      this.$refs.audio.currentTime = parseInt(
        this.$refs.audio.duration * seekPos
      );
    },
    stopPlayer() {
      this.pause();
      this.$refs.audio.currentTime = 0;
    },
    update() {
      this.currentSeconds =
        parseInt(this.$refs.audio.currentTime) +
        parseInt(this.currentSilence / 1000);
    },
    stopAudios() {
      this.pause();
      this.stopAudio();
    },
  },
};
</script>
<style scoped>
.player {
  /* background-color: white; */
  border-radius: 5px;
  color: #2c3b58;
  display: inline-block;
  line-height: 1.5625;
  width: 100% !important;
}

.player-controls {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
}

.timeInfo {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.player-controls div a {
  color: green;
  display: block;
  line-height: 0;
  padding: 1em;
  text-decoration: none;
}

.player-controls div a svg {
  display: inline-block;
  width: 1.125rem;
}

.player-progress {
  cursor: pointer;
  border-radius: 4px;
  height: 5px;
  min-width: 100%;
  max-width: 100%;
  position: relative;
  background: rgba(119, 127, 246, 0.31);
}

.player-seeker {
  background-color: #777ff6;
  border-radius: 4px;
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
}

.player-time {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.player-time-current {
  font-size: 14px;
  color: #98a7ad;
}

.player-time-total {
  font-size: 14px;
  color: #98a7ad;
}

.player-volume {
  display: inline-block;
  height: 1.1rem;
  margin: 0 0 0 2px;
  width: 6rem;
}
.audioBtn {
  width: 100%;
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
}
</style>
